
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PlanAnualPesv {
  id?: number;
  version: string;
  codigo: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  estado?: number;
  fechacreacion?: string;
  fechamodificacion?: string;
  archivo?: string;
}

@Injectable({ providedIn: 'root' })
export class PlanAnualService {
    private apiUrl = `${environment.apiUrl}/api/plan_anual_pesv`;

  constructor(private http: HttpClient) {}

  // Descargar archivo asociado a un plan anual
  descargarArchivo(id: number, archivo: string): Observable<Blob> {
    const url = `${this.apiUrl}/${id}/descargar?archivo=${encodeURIComponent(archivo)}`;

    return this.http.get(url, {
      responseType: 'blob',
      observe: 'response',
      withCredentials: true
    }) as Observable<any>;
  }

  getAll(): Observable<PlanAnualPesv[]> {
    return this.http.get<PlanAnualPesv[]>(this.apiUrl);
  }

  getById(id: number): Observable<PlanAnualPesv> {
    return this.http.get<PlanAnualPesv>(`${this.apiUrl}/${id}`);
  }

create(data: any): Observable<any> {
  return this.http.post(this.apiUrl, data);
}

  update(id: number | string, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data, { withCredentials: true }).pipe(
          map((res) => res?.data ?? res),
        );
  }

  inactivar(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  activar(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  delete(id: number | string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }
}